import { render, staticRenderFns } from "./VideoCategory.vue?vue&type=template&id=44c319a4&scoped=true"
import script from "./VideoCategory.vue?vue&type=script&lang=js"
export * from "./VideoCategory.vue?vue&type=script&lang=js"
import style0 from "./VideoCategory.vue?vue&type=style&index=0&id=44c319a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c319a4",
  null
  
)

export default component.exports